module.exports = "/_next/static/images/maryland-4bbb4f6644c5aba46bc93192d488f25d.svg";